module.exports = __webpack_public_path__ + "static/media/twitter.7f221c77.svg";